import React from 'react';
import Breadcrumbs from '../../components/Breadcrumbs';
import QuestionAnswerSection from './QuestionAnswerSection';
import { FAQ } from './IFAQAnswer';
import { currentUrl } from '../../helpers/projectConstant';
import DefaultLayout from '../../layouts/DefaultLayout';
import Container from '../../components/ui/Container';
import Panel from '../../components/ui/Panel';

export const FAQAnswerPage: React.FC<FAQ> = ({ faqId, faqText, faqTitle }) => {
  const breadcrumbLinks = [
    { name: 'Home', linkTo: '/' },
    { name: 'Veelgestelde vragen', linkTo: `/home/faq` },
    { name: 'Alle vragen', linkTo: '/home/faqoverzicht' },
    { name: 'Details', linkTo: currentUrl },
  ];

  return (
    <DefaultLayout breadcrumbs={<Breadcrumbs links={breadcrumbLinks} />}>
      <Container state="defaultLayoutFirst">
        <Panel variant="collapsed" position="last">
          <QuestionAnswerSection
            faqId={faqId}
            faqText={faqText}
            faqTitle={faqTitle}
          />
        </Panel>
      </Container>
    </DefaultLayout>
  );
}

FAQAnswerPage.displayName = "Page:FaqItem";

export default FAQAnswerPage;